import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CotalityCream from '../../assets/images/cotality-cream.png';
import { colors } from '../../theme';

export const SkilljarHeader = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      position="sticky"
      top={0}
      zIndex={99}
      width="100%"
      height={80}
      bgcolor={colors.black}
      borderBottom="1px solid #4d4d4d"
    >
      <Box maxWidth={1280} width="100%" m="auto" px={4}>
        <Box component="img" src={CotalityCream} alt="Cotality" height={52} />
      </Box>
    </Stack>
  );
};
